// Reveals the sidebar nav's scrollbar only while the user is actively scrolling,
// then fades it out shortly after — replacing the previous hover-to-reveal
// behavior (the scrollbar appearing on mere hover felt noisy on short screens).
//
// Used as a React 19 ref callback on `.portal-shell__nav`: it wires a passive
// scroll listener that toggles the `is-scrolling` class (driven from the DOM, so
// no React re-renders) and returns the cleanup run on unmount.

// How long the scrollbar lingers after the last scroll event before fading.
const SCROLL_IDLE_MS = 800

export const attachNavScrollReveal = (el: HTMLElement | null): (() => void) | undefined => {
    if (!el) return undefined

    let timer: ReturnType<typeof setTimeout> | undefined
    const onScroll = () => {
        el.classList.add('is-scrolling')
        if (timer) clearTimeout(timer)
        timer = setTimeout(() => el.classList.remove('is-scrolling'), SCROLL_IDLE_MS)
    }

    el.addEventListener('scroll', onScroll, { passive: true })

    return () => {
        el.removeEventListener('scroll', onScroll)
        if (timer) clearTimeout(timer)
    }
}
